import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LaundryModal from '../../common/LaundryModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as laundriesActions from '../../actions/Laundries'

class NewLaundryModal extends Component {
  state = {
    nameInput: '',
    outOfOrder: false,
    errorName: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { laundries, data } = this.props
    const laundryType = data.laundrySystem.laundryRule.laundryType

    if (
      !nextProps.laundries.isCreating &&
      nextProps.laundries.errorCreating === null &&
      laundries.isCreating
    ) {
      this.props.hideCreateLaundryModal()
      this.props.showSnackbar(Strings.default.LAUNDRY_CREATED[laundryType])
      this.resetFields()
    } else if (
      !nextProps.laundries.isCreating &&
      nextProps.laundries.errorCreating !== null &&
      laundries.isCreating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  createLaundry() {
    const { data, user } = this.props
    const { nameInput, outOfOrder } = this.state

    this.setState({ errorMessage: '' })

    if (nameInput === '') {
      this.setState({ errorName: Strings.default.MANDATORY_FIELD })
    }

    if (nameInput !== '') {
      const postData = {
        name: nameInput,
        functioning: !outOfOrder
      }

      this.props.tryCreateLaundry(user.token, data.community.id, postData)
    }
  }

  resetFields() {
    this.setState({
      nameInput: '',
      outOfOrder: false,
      errorName: '',
      errorMessage: ''
    })
  }

  render() {
    const { config, laundries, data } = this.props
    const { nameInput, errorName, errorMessage, outOfOrder } = this.state
    const laundryType = data.laundrySystem.laundryRule.laundryType

    return (
      <LaundryModal
        show={config.createLaundryModal.show}
        hide={() => {
          this.resetFields()
          this.props.hideCreateLaundryModal()
        }}
        nameInput={nameInput}
        onChangeNameInput={text =>
          this.setState({
            nameInput: text,
            errorName: '',
            errorMessage: ''
          })
        }
        outOfOrder={outOfOrder}
        onChangeOutOfOrder={checked => this.setState({ outOfOrder: checked })}
        errorName={errorName}
        header={Strings.default.NEW_LAUNDRY[laundryType]}
        information={Strings.default.NEW_LAUNDRY_INFORMATION[laundryType]}
        onDone={() => this.createLaundry()}
        loading={laundries.isCreating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, laundries }) {
  return { config, data, user, laundries }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...laundriesActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NewLaundryModal)



// WEBPACK FOOTER //
// ./src/components/containers/NewLaundryModal/index.js